// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__q73kU","title":"ClientReferral_title__1WWIe","itemText":"ClientReferral_itemText__3KV-H"};